import { useEffect, useState } from "react";
import { IProject, Project } from "../types";
import { useFuzzySearch } from "./useFuzzySearch";
import { useProjectStore } from "../store/project-store";

export function useProjectSearch(key: string) {
  const { projectList } = useProjectStore();
  const [searchResult, setSearchResult] = useState<Project.Info[]>();
  const { fuzzySearch } = useFuzzySearch(projectList as IProject[], key);

  function search(searchInput: string) {
    if (!searchInput) {
      setSearchResult(projectList);
      return;
    }
    setSearchResult(fuzzySearch(searchInput));
  }

  useEffect(() => {
    setSearchResult(projectList);
  }, [projectList]);

  return {
    searchResult,
    search,
  };
}
